import { useInfiniteQuery } from '@tanstack/react-query';
import axios from 'axios';
import API from '@/apiRequest';
import { ITEMS_PER_PAGE } from '@/constants';

/**
 * Hook for searching and listing orders with infinite scroll.
 * Handles search string, tags, and status filtering.
 */
export const useOrders = ({
  search = '',
  tags = [],
  type = '',
  status = 'all',
  orderByDir = 'desc',
}) => {
  return useInfiniteQuery({
    queryKey: ['orders', { search, tags, type, status, orderByDir }],
    queryFn: async ({ pageParam = 0 }) => {
      const apiStatus = status === 'search' ? 'all' : status;
      const response = await API.get('orders', {
        params: {
          limit: ITEMS_PER_PAGE,
          offset: pageParam,
          search: search || undefined,
          tags: tags.length ? tags : undefined,
          status: apiStatus,
          type: type || undefined,
          order_by: 'created_at',
          order_by_dir: orderByDir,
        },
      });
      return response.data;
    },
    retry: false,
    getNextPageParam: (lastPage, allPages) => {
      // If the last page has fewer items than requested, we've reached the end
      if (lastPage.length < ITEMS_PER_PAGE) return undefined;
      // Next offset is the current count of loaded items
      return allPages.length * ITEMS_PER_PAGE;
    },
    initialPageParam: 0,
    // Flattening logic can be handled in the component for the OrdersList format
  });
};
